import type { QueueBoardRoom } from "../types";
import { queueFont } from "../queueFont";
import { WelcomeHeader } from "./WelcomeHeader";
import { CareCornerLogo } from "./CareCornerLogo";

type RoomCardsGridProps = {
  clinicName: string;
  rooms: QueueBoardRoom[];
};

export function RoomCardsGrid({ clinicName, rooms }: RoomCardsGridProps) {
  return (
    <div
      className={`${queueFont} relative box-border flex min-h-screen w-full max-w-[100vw] select-none flex-col overflow-x-hidden bg-white antialiased`}
    >
      <CareCornerLogo variant="grid" />

      <WelcomeHeader clinicName={clinicName} layout="inline" />

      <div className="flex min-h-0 w-full flex-1 items-stretch justify-center overflow-x-hidden overflow-y-auto px-[clamp(20px,3.5vmin,64px)] pb-[clamp(96px,11vmin,160px)]">
        {rooms.length === 0 ? (
          <div
            className={`${queueFont} max-w-[520px] self-center p-[clamp(24px,4vmin,48px)] text-center text-lg leading-normal text-[#334155]`}
          >
            No rooms are configured for this clinic yet. Add rooms in Settings (Manage time → Rooms), then
            refresh this page.
          </div>
        ) : (
          <div className="mx-auto grid w-full max-w-[min(1800px,96vw)] grid-cols-[repeat(auto-fit,minmax(min(240px,100%),1fr))] gap-[clamp(16px,2.2vmin,32px)] self-center">
            {rooms.map((room) => (
              <div
                key={room.id}
                className={`${queueFont} flex min-h-[clamp(320px,46vmin,560px)] min-w-0 flex-col items-center justify-center rounded-[clamp(12px,1.5vmin,20px)] border-[clamp(1px,0.15vmin,2px)] border-solid border-[#cbd5e1] bg-gradient-to-b from-slate-50 to-white px-[clamp(20px,3.4vmin,40px)] py-[clamp(28px,4.5vmin,52px)] text-center shadow-[0_8px_28px_rgba(15,23,42,0.07)]`}
              >
                <div className="flex max-w-full flex-col items-center gap-[14px]">
                  <div
                    className={`${queueFont} w-full break-words text-[22px] font-extrabold leading-snug text-[#0b3a66] [overflow-wrap:anywhere] [text-rendering:optimizeLegibility]`}
                  >
                    {room.name}
                  </div>
                  <div
                    className={`${queueFont} w-full break-words text-lg font-semibold leading-snug text-[#334155] [overflow-wrap:anywhere] [text-rendering:optimizeLegibility]`}
                  >
                    {room.doctorName}
                  </div>
                  <div className="text-[13px] font-bold uppercase leading-tight tracking-[0.14em] text-slate-500">
                    Now serving
                  </div>
                  <div
                    className={`${queueFont} w-full text-[160px] font-extrabold leading-none text-[#0b3a66] [font-variant-numeric:tabular-nums] [text-rendering:optimizeLegibility]`}
                  >
                    {room.currentQueue}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
